import { getPortfolioById } from 'api/operations/productServiceV2';
import { RequiredCrossSellViolation } from 'global/utils/crossSellHelper';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import ModalDelegate from 'store/general/modalDelegate';

async function fetchPortfolioNamesById(portfolioIds: string[]): Promise<Map<string, string>> {
  const portfolioNameById = new Map<string, string>();

  // The BE doesn't provide an endpoint to fetch multiple portfolios by ID without browsing criteria,
  // so each portfolio is fetched individually.
  await Promise.all(
    portfolioIds.map(async (portfolioId) => {
      const { name } = await getPortfolioById(portfolioId);
      portfolioNameById.set(portfolioId, name);
    }),
  );

  return portfolioNameById;
}

export default class RequiredCrossSellModalDelegate extends ModalDelegate {
  private _violations: RequiredCrossSellViolation[] = [];

  public get violations(): RequiredCrossSellViolation[] {
    return this._violations;
  }

  public async openModal(violations: RequiredCrossSellViolation[]): Promise<void> {
    this.setIsLoading(true);
    super.open();

    const requiredPortfolioIds = [...new Set(violations.map((violation) => violation.requiredPortfolioId))];
    const portfolioNameById = await fetchPortfolioNamesById(requiredPortfolioIds);

    runInAction(() => {
      this._violations = violations.map((violation) => ({
        ...violation,
        requiredPortfolioName: portfolioNameById.get(violation.requiredPortfolioId),
      }));
      this.setIsLoading(false);
    });
  }

  public closeModal(): void {
    super.close();
    this._violations = [];
    this.setIsLoading(false);
  }

  constructor() {
    super();
    makeObservable<RequiredCrossSellModalDelegate, '_violations'>(this, {
      _violations: observable.shallow,
      violations: computed,
      openModal: action.bound,
      closeModal: action.bound,
    });
  }
}
